import { render, staticRenderFns } from "./MyOrganization.vue?vue&type=template&id=90edef96&scoped=true&"
import script from "./MyOrganization.vue?vue&type=script&lang=js&"
export * from "./MyOrganization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90edef96",
  null
  
)

export default component.exports